export default "__VITE_ASSET__BE9ElJel__"